import { Group } from 'modules/expenses/hooks/useGroup'

export const isDraftGroup = (group: Group) => group.status === 'draft'

export const isPendingGroup = (group: Group) => group.status === 'pending'

export const isChangesRequestedGroup = (group: Group) => group.status === 'changes_requested'

export const isRejectedGroup = (group: Group) => group.status === 'rejected'
